import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { of } from "rxjs";
import {
  catchError,
  filter,
  map,
  switchMap,
  withLatestFrom,
} from "rxjs/operators";
import { GenericApiData } from "src/components/shared-components/class/general-classes/generic-api-data";
import {
  CardProgrammerStoreAction,
  StorageNativeStoreAction,
} from "src/components/shared-components/enum/enumStoreAction";
import { GenericUserData } from "src/model/interface/generic-user-data";
import { CardProgrammerService } from "src/service/card-programmer.service";
import {
  cardProgrammerLoadErrorAction,
  cardProgrammerLoadSuccessAction,
  cardProgrammerUnsetKeyStoreAction,
} from "../actions/card-programmer.actions";
import { currentUserData } from "../selectors/authentication.selectors";

/**
 * Handle generic side ngrx effect from area action
 */
@Injectable()
export class CardProgrammerEffects {
  constructor(
    private _actions$: Actions,
    private _cardProgrammerService: CardProgrammerService,
    private _store: Store
  ) { }

  /**
   * Effect who catch main event and unset specific server key storage
   */
  public cardProgrammerUnsetStorageEffect = createEffect(() =>
    this._actions$.pipe(
      ofType(StorageNativeStoreAction.STORAGE_UNSET_ALL_AUTH_KEY),
      map((action) => cardProgrammerUnsetKeyStoreAction())
    )
  );

  /**
   * Effet attached to ngrx store init, then start init initialization
   */
  public cardProgrammerInitEffect = createEffect(() =>
    this._actions$.pipe(
      ofType(CardProgrammerStoreAction.CARD_PROGRAMMER_START_LOAD),
      withLatestFrom(this._store.select(currentUserData)),
      filter(
        (combinedObject) =>
          !!(combinedObject[1] as GenericUserData)?.currentUser
      ),
      switchMap((action: any) => {
        return this._cardProgrammerService.getListCardProgrammer().pipe(
          map((listCardProgrammerObject: GenericApiData) =>
            cardProgrammerLoadSuccessAction({ listCardProgrammerObject })
          ),
          catchError(() => of(cardProgrammerLoadErrorAction()))
        );
      })
    )
  );
}
